export default __webpack_public_path__ + "static/media/jms-infusion-500.c31354f7.jpg";